import { Navigate, useParams } from "react-router-dom";
import SaveTomaFisica from "../../shared/save_toma_fisica/SaveTomaFisica";
import { useFetchGetTomaFisicaById } from "@/shared/actions/erp/contabilidad/toma_fisica.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";

export default function EditTomaFisicaPage() {

  const { id } = useParams();

  const {
    data,
    isLoading,
  } = useFetchGetTomaFisicaById(id!)

  if (isLoading)
    return <LoaderComponent />

  if (!data?.data)
    return <Navigate to={`${ROUTER_PATHS.inventario.tomaFisicaHistorialNav}`} />

  return (
    <SaveTomaFisica
      enabledFilter={true}
      title="Editar Toma Fisica"
      dataTomaFisica={data.data}
    />
  )

}